import { PhoneMissed, Voicemail, X } from "lucide-react";
import type React from "react";

import { type Lead } from "@/app/(authenticated)/leads/_modules/types/get-leads-type";
import { Button } from "@/app/_module/components/ui/button";
import {
  Dialog,
  ResponsiveDialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/app/_module/components/ui/dialog";

interface VoicemailPromptModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  lead: Lead;
  onLeaveVoicemail: () => void;
  onSkip: () => void;
}

export const VoicemailPromptModal: React.FC<VoicemailPromptModalProps> = function({
  open,
  onOpenChange,
  lead,
  onLeaveVoicemail,
  onSkip,
}) {
  const handleLeaveVoicemail = () => {
    onOpenChange(false);
    onLeaveVoicemail();
  };

  const handleSkip = () => {
    onOpenChange(false);
    onSkip();
  };

  return (
    <Dialog onOpenChange={onOpenChange} open={open}>
      <ResponsiveDialogContent size="md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <PhoneMissed className="h-5 w-5 text-orange-600" />
            Call Not Answered
          </DialogTitle>
          <DialogDescription>
            What would you like to do next for {lead.name}?
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-4 py-4">
          <div className="text-center">
            <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-3">
              <PhoneMissed className="h-8 w-8 text-orange-600" />
            </div>
            <h3 className="text-lg font-semibold mb-2">{lead.name}</h3>
            <p className="text-sm text-muted-foreground font-mono">{lead.phone}</p>
          </div>

          <div className="bg-orange-50 border border-orange-200 rounded-lg p-4">
            <p className="text-center text-orange-800 font-medium">
              The call wasn't answered.
            </p>
            <p className="text-center text-orange-700 text-sm mt-1">
              Do you want to leave a voicemail?
            </p>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-3">
          <Button
            className="w-full"
            onClick={handleSkip}
            variant="outline"
          >
            <X className="h-4 w-4 mr-2" />
            Skip
          </Button>
          <Button
            className="w-full bg-blue-600 hover:bg-blue-700"
            onClick={handleLeaveVoicemail}
          >
            <Voicemail className="h-4 w-4 mr-2" />
            Leave Voicemail
          </Button>
        </div>
      </ResponsiveDialogContent>
    </Dialog>
  );
};
